import { createAsyncThunk } from "@reduxjs/toolkit";
import DataService from "../service";
import { constant } from "../constant";
const { path } = constant;
export const fetchDashboardList = createAsyncThunk(
  "dashboard/fetchDashboard",
  (arg, { rejectWithValue }) =>
    DataService.get(arg, path + "client/account/v1/dashboard", rejectWithValue)
);
export const fetchDashboardChart = createAsyncThunk(
  "dashboard/fetchDashboardChart",
  (arg, { rejectWithValue }) =>
    DataService.get(
      arg,
      path +
        `client/account/v1/dashboard-graph`,
      rejectWithValue
    )
);

export const AddReportTime = createAsyncThunk(
  "client/AddReportTime",
  (arg, { rejectWithValue }) =>
    DataService.post(arg, path + "client/account/v1/add-time-slot", rejectWithValue)
);

export const EditReportTime = createAsyncThunk(
  "client/EditReportTime",
  (arg, { rejectWithValue }) =>
    DataService.post(arg, path + "client/account/v1/update-time-slot", rejectWithValue)
);

export const deleteTime = createAsyncThunk(
  "client/deleteTime",
  (arg, { rejectWithValue }) =>
    DataService.delete(arg, path + "client/account/v1/delete-time-slot", rejectWithValue)
);

export const updateTimeStatus = createAsyncThunk(
  "client/updateTimeStatus",
  (arg, { rejectWithValue }) =>
    DataService.post(arg, path + "client/account/v1/toggle-time-slot", rejectWithValue)
);

export const toggleReportTimeActivation = createAsyncThunk(
  "client/toggleReportTimeActivation",
  (arg, { rejectWithValue }) =>
    DataService.post(arg, path + "client/account/v1/toggle-time-slot", rejectWithValue)
);
